import { render, staticRenderFns } from "./HelpCenterMain.vue?vue&type=template&id=0f193c9c&scoped=true&"
import script from "./HelpCenterMain.vue?vue&type=script&lang=js&"
export * from "./HelpCenterMain.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterMain.vue?vue&type=style&index=0&id=0f193c9c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f193c9c",
  null
  
)

export default component.exports